import React from 'react';
import PropTypes from 'prop-types';
import {Loading} from 'modules/legacy/js/lib/components';

export default function LoadingState({height = '30rem', className = ''}) {
  return (
    <div className='width100' style={{height}}>
      <Loading active className={className} />
    </div>
  );
}

LoadingState.propTypes = {
  height: PropTypes.string
};
